import { styled } from '@ingrid/luterkort-react';

export const Wrapper = styled('div', {
  flexDirection: 'column',
  display: 'flex',
  height: '100%',
});

export const Footer = styled('div', {
  borderTop: '1px solid $color-e9',
  justifyContent: 'space-between',
  marginBottom: '-16px',
  marginLeft: '-16px',
  width: 'calc(100%)',
  display: 'flex',
  padding: '16px',

  variants: {
    mode: {
      dark: {
        borderTop: '1px solid $grey-33',
      },
    },
  },
});
